export const pomegranateTokens = {
    tokens: {
        blendBackground: '#ff5996',
        blendIntersection: '#6e00f5',
        blendForeground: '#9966ff',
        gradientColorZero: '#a54ddd',
        gradientColorOne: '#ff80ff',
        gradientColorTwo: '#ffb422',
        gradientColorThree: '#fe94d4',
        gradientColorZeroTransparent: '#ff599600',
        gradientColorOneTransparent: '#ff80ff00',
        gradientColorTwoTransparent: '#ffb42200',
        gradientColorThreeTransparent: '#fe94d400',
        shadeOneColor: '#9d46d5',
        shadeTwoColor: '#7b58e1',
        shadeThreeColor: '#635bff',
        shadeFourColor: '#0a2540'
    },
    themeTokens: {
        dark: {
            blendBackground: '#ff5996',
            blendIntersection: '#ffdcf2',
            blendForeground: '#9966ff',
            accentColor: '#ff5996'
        }
    },
    accents: {
        raspberry: {
            tokens: {
                accentColor: '#ff5996'
            }
        },
        purple: {
            themeTokens: {
                dark: {
                    accentColor: '#9966ff'
                }
            }
        }
    }
};

//# sourceMappingURL=Pomegranate.js.map